import { describeMatchStrategy, type VatechCtCatalogStudy } from "./domain/vatechCtCatalog"

export function VatechCtCatalogTable({
  studies,
  selectedStudyUid,
  onSelectStudy,
  disabled = false,
  resolveStrategy,
}: {
  studies: VatechCtCatalogStudy[]
  selectedStudyUid: string
  onSelectStudy: (studyUid: string) => void
  disabled?: boolean
  resolveStrategy?: string | null
}) {
  if (studies.length === 0) return null

  return (
    <div className="space-y-2">
      {resolveStrategy ? (
        <span className="text-xs text-slate-500">Стратегия: {describeMatchStrategy(resolveStrategy)}</span>
      ) : null}
      <div className="overflow-x-auto rounded-xl border border-slate-200">
        <table className="min-w-full text-sm">
          <thead className="bg-slate-50 text-left text-xs text-slate-500">
            <tr>
              <th className="px-3 py-2">Дата</th>
              <th className="px-3 py-2">Папка</th>
              <th className="px-3 py-2">Пациент</th>
              <th className="px-3 py-2">Статус</th>
              <th className="px-3 py-2">Выбор</th>
            </tr>
          </thead>
          <tbody>
            {studies.map((study) => {
              const hasAnalysisReady = Boolean(
                study.diagnocat_analysis_ready || (study.diagnocat_analyses_count ?? 0) > 0,
              )
              return (
              <tr key={study.study_uid} className="border-t border-slate-100">
                <td className="px-3 py-2">{study.study_date ?? "—"}</td>
                <td className="px-3 py-2">
                  {study.folder_name ?? study.raw_folder_name ?? "—"}
                  {study.modality ? ` · ${study.modality}` : ""}
                </td>
                <td className="px-3 py-2 text-slate-500">{study.patient_name ?? "—"}</td>
                <td className="px-3 py-2">
                  <div className="flex flex-wrap gap-1 text-xs">
                    {hasAnalysisReady ? (
                      <span className="rounded bg-emerald-100 px-2 py-0.5 text-emerald-800">
                        анализ готов
                        {study.diagnocat_analyses_ready_count
                          ? ` (${study.diagnocat_analyses_ready_count})`
                          : study.diagnocat_analyses_count
                            ? ` (${study.diagnocat_analyses_count})`
                            : ""}
                      </span>
                    ) : study.already_in_diagnocat ? (
                      <span className="rounded bg-sky-100 px-2 py-0.5 text-sky-800">в Diagnocat, без анализа</span>
                    ) : (
                      <span className="rounded bg-slate-100 px-2 py-0.5 text-slate-600">нет в Diagnocat</span>
                    )}
                    {study.match_strategy === "patient_name" ? (
                      <span className="rounded bg-amber-100 px-2 py-0.5 text-amber-800">match: ФИО</span>
                    ) : null}
                    {!study.submit_eligible ? (
                      <span className="rounded bg-slate-100 px-2 py-0.5 text-slate-600">после связки</span>
                    ) : null}
                  </div>
                </td>
                <td className="px-3 py-2">
                  <input
                    type="radio"
                    name="vatech-ct-study"
                    checked={selectedStudyUid === study.study_uid}
                    disabled={disabled}
                    onChange={() => onSelectStudy(study.study_uid)}
                  />
                </td>
              </tr>
            )})}
          </tbody>
        </table>
      </div>
    </div>
  )
}
